<script lang="ts">
  import AccordionChevron from '$icons/AccordionChevronIcon.svelte';
  import { fade } from 'svelte/transition';

  export let isExpanded = false;
  export let isExpandable: boolean;
  export let hideArrowAndExpand = false;

  export let title: string;

  function toggle() {
    if (!isExpandable) {
      return;
    }

    isExpanded = !isExpanded;
  }
</script>

<div class="select-none cursor-pointer {$$props.class}" class:!cursor-not-allowed={!isExpandable}>
  <button class="flex w-full justify-between" on:click={toggle} on:keypress={toggle}>
    <div class="">
      <div class="text-blueish-grey-900 font-bold">{title}</div>
    </div>

    {#if !hideArrowAndExpand}
      <button
        class:-rotate-90={!isExpanded}
        disabled={!isExpandable}
        class="disabled:text-garden-grey-300 duration-200 h-6 self-start"
      >
        <AccordionChevron />
      </button>
    {/if}
  </button>

  <slot name="filter-chips" />

  {#if isExpanded || hideArrowAndExpand}
    <div transition:fade={{ duration: 200 }}>
      <slot name="filter-details" />
    </div>
  {/if}
</div>
